import { render, staticRenderFns } from "./GraficaNovedadesInspecciones.vue?vue&type=template&id=3a824094"
import script from "./GraficaNovedadesInspecciones.vue?vue&type=script&lang=js"
export * from "./GraficaNovedadesInspecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports